'use strict';
/**
    * Logs the msg to the console.
    * @param {string} msg to print in console
    * @returns {null}
    */
function _log(msg) {
    if (window.console) {
        console.log(msg);
    }
}

module.exports = _log;


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/util/log.js
 ** module id = 15
 ** module chunks = 0
 **/